import CoreBase from '../../../../../../services/engines/CoreBase';
import userTopicService from '../../../../../../services/UserTopicService';

class SearchDrawerFetcher extends CoreBase {
    _name = 'SearchDrawerFetcher';

    /**
     * Fetches all topic groups for the current user.
     * @returns {object[]|null}
     */
    fetchTopics = async () => {
        try {
            const resp = await userTopicService.getGroups();
            if (resp === -1 || !resp?.data) return null;
            return resp.data;
        } catch (error) {
            this.logError('fetchTopics', error.message);
            return null;
        }
    };

    /**
     * Fetches search results.
     * Passes panelId as rk for server-side correlation logging.
     * @param {string} query
     * @param {string} topic - empty string = all topics
     * @param {number} page
     * @param {number} size
     * @param {string} panelId - correlation id, sent as rk param
     * @returns {{ items: object[], total: number, page: number }|null}
     */
    fetch = async (query, topic, page = 1, size = 25, panelId = '') => {
        try {
            // const q = topic ? `${query} service:${topic}` : query;

            const q = query;
            const resp = await userTopicService.search({ q, topic, page, size, rk: panelId });

            if (resp === -1 || !resp?.data) return null;
            return {
                total: resp.data.totalItems ?? 0,
                items: resp.data.items ?? [],
                page: resp.data.page ?? 1,
            };
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };
}

const searchDrawerFetcher = new SearchDrawerFetcher();
export default searchDrawerFetcher;
